<template>
  <div>
    <v-container fluid class="px-15 pb-10 pt-4">
      <!-- Header -->
      <v-row justify="start" align="start" class="ma-0 mt-5 mb-5">
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-bold'; font-size: 24px; color: #000000;">
            Calculadora de Precios
          </div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-regular'; font-size: 14px; color: #707070;">
            Calcula el precio FOB de tus productos
          </div>
        </v-col>
      </v-row>

      <!-- Tabs -->
      <v-tabs v-model="activeTab" background-color="transparent" color="#000000" class="mb-6">
        <v-tab>
          <v-icon left small>mdi-calculator</v-icon>
          Calculadora
        </v-tab>
        <v-tab>
          <v-icon left small>mdi-history</v-icon>
          Historial ({{ calculations.length }})
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="activeTab">
        <!-- ==================== TAB CALCULADORA ==================== -->
        <v-tab-item>
          <v-card class="pa-6" style="border-radius: 16px; border: 1px solid #c5cdd3;" elevation="2">
            <v-row>
              <!-- ===== COLUMNA DERECHA: Datos Numéricos + Resultado ===== -->
              <v-col cols="12" lg="6" order="2">
                <div class="d-flex align-center mb-4">
                  <v-icon color="#15803d" class="mr-2">mdi-currency-usd</v-icon>
                  <span style="font-family: 'montserrat-bold'; font-size: 16px; color: #000000;">
                    Datos Numéricos
                  </span>
                </div>

                <!-- Precio Unitario (modo cost) -->
                <v-row v-if="calcMode === 'cost'" dense class="mb-2">
                  <v-col cols="12">
                    <div class="d-flex align-center justify-space-between mb-1">
                      <div style="font-family: 'montserrat-medium'; font-size: 13px; color: #555;">
                        <v-icon x-small color="#16a34a" class="mr-1">mdi-currency-usd</v-icon>
                        Precio Unitario por Caja
                      </div>
                      <v-btn-toggle v-model="currencies.unitPrice" mandatory dense class="currency-toggle">
                        <v-btn x-small value="USD" style="text-transform: none; font-family: 'montserrat-medium'; font-size: 11px;">USD</v-btn>
                        <v-btn x-small value="MXN" style="text-transform: none; font-family: 'montserrat-medium'; font-size: 11px;">MXN</v-btn>
                      </v-btn-toggle>
                    </div>
                    <v-text-field
                      v-model="form.dUnitPrice"
                      type="number"
                      step="0.01"
                      placeholder="0.00"
                      outlined
                      dense
                      hide-details
                      style="border-radius: 10px;"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Precio de Mercado (modo maxpay) -->
                <v-row v-else dense class="mb-2">
                  <v-col cols="12">
                    <div style="font-family: 'montserrat-medium'; font-size: 13px; color: #555;" class="mb-1">
                      <v-icon x-small color="#16a34a" class="mr-1">mdi-currency-usd</v-icon>
                      Precio de Mercado (USD / caja)
                    </div>
                    <v-text-field
                      v-model="form.bMarketPrice"
                      type="number"
                      step="0.01"
                      placeholder="0.00"
                      outlined
                      dense
                      hide-details
                      style="border-radius: 10px;"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Cajas/Pallets -->
                <v-row v-if="unit === 'boxes'" dense class="mb-2">
                  <v-col cols="6">
                    <div style="font-family: 'montserrat-medium'; font-size: 13px; color: #555;" class="mb-1">
                      <v-icon x-small color="#2563eb" class="mr-1">mdi-package-variant</v-icon>
                      Total de Cajas
                    </div>
                    <v-text-field
                      v-model="form.dTotalBoxesDirect"
                      type="number"
                      step="1"
                      placeholder="1040"
                      outlined
                      dense
                      hide-details
                      style="border-radius: 10px;"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6" v-if="unit === 'pallets'">
                    <div style="font-family: 'montserrat-medium'; font-size: 13px; color: #555;" class="mb-1">
                      <v-icon x-small color="#2563eb" class="mr-1">mdi-package-variant</v-icon>
                      Cajas por Pallet
                    </div>
                    <v-text-field
                      v-model="form.dBoxesPerPallet"
                      type="number"
                      step="1"
                      placeholder="40"
                      outlined
                      dense
                      hide-details
                      style="border-radius: 10px;"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-else dense class="mb-2">
                  <v-col cols="6">
                    <div style="font-family: 'montserrat-medium'; font-size: 13px; color: #555;" class="mb-1">
                      <v-icon x-small color="#2563eb" class="mr-1">mdi-package-variant</v-icon>
                      Cajas por Pallet
                    </div>
                    <v-text-field
                      v-model="form.dBoxesPerPallet"
                      type="number"
                      step="1"
                      placeholder="40"
                      outlined
                      dense
                      hide-details
                      style="border-radius: 10px;"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <div style="font-family: 'montserrat-medium'; font-size: 13px; color: #555;" class="mb-1">
                      <v-icon x-small color="#9333ea" class="mr-1">mdi-shipping-pallet</v-icon>
                      Total de Pallets
                    </div>
                    <v-text-field
                      v-model="form.sTotalPallets"
                      type="number"
                      step="1"
                      placeholder="26"
                      outlined
                      dense
                      hide-details
                      style="border-radius: 10px;"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Flete + Costo Aduanal (misma fila, ocultos si override activo) -->
                <v-row v-if="!useLogisticsOverride" dense class="mb-2">
                  <v-col cols="6">
                    <div class="d-flex align-center justify-space-between mb-1">
                      <div style="font-family: 'montserrat-medium'; font-size: 13px; color: #555;">
                        <v-icon x-small color="#ea580c" class="mr-1">mdi-truck</v-icon>
                        Flete
                      </div>
                      <v-btn-toggle v-model="currencies.freight" mandatory dense class="currency-toggle">
                        <v-btn x-small value="USD" style="text-transform: none; font-family: 'montserrat-medium'; font-size: 11px;">USD</v-btn>
                        <v-btn x-small value="MXN" style="text-transform: none; font-family: 'montserrat-medium'; font-size: 11px;">MXN</v-btn>
                      </v-btn-toggle>
                    </div>
                    <v-text-field
                      v-model="form.dFreight"
                      type="number"
                      step="0.01"
                      placeholder="0.00"
                      outlined
                      dense
                      hide-details
                      style="border-radius: 10px;"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <div class="d-flex align-center justify-space-between mb-1">
                      <div style="font-family: 'montserrat-medium'; font-size: 13px; color: #555;">
                        <v-icon x-small color="#4f46e5" class="mr-1">mdi-shield-check</v-icon>
                        Costo Aduanal
                      </div>
                      <v-btn-toggle v-model="currencies.customsFee" mandatory dense class="currency-toggle">
                        <v-btn x-small value="USD" style="text-transform: none; font-family: 'montserrat-medium'; font-size: 11px;">USD</v-btn>
                        <v-btn x-small value="MXN" style="text-transform: none; font-family: 'montserrat-medium'; font-size: 11px;">MXN</v-btn>
                      </v-btn-toggle>
                    </div>
                    <v-text-field
                      v-model="form.sCustomsFee"
                      type="number"
                      step="0.01"
                      placeholder="0.00"
                      outlined
                      dense
                      hide-details
                      style="border-radius: 10px;"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- In/Out por Pallet (oculto si override activo) -->
                <v-row v-if="!useLogisticsOverride" dense class="mb-2">
                  <v-col cols="12">
                    <div class="d-flex align-center justify-space-between mb-1">
                      <div style="font-family: 'montserrat-medium'; font-size: 13px; color: #555;">
                        <v-icon x-small color="#d97706" class="mr-1">mdi-warehouse</v-icon>
                        {{ unit === 'pallets' ? 'Tarifa In/Out por Pallet' : 'Tarifa completa In/Out' }}
                      </div>
                      <v-btn-toggle v-model="currencies.inOutRate" mandatory dense class="currency-toggle">
                        <v-btn x-small value="USD" style="text-transform: none; font-family: 'montserrat-medium'; font-size: 11px;">USD</v-btn>
                        <v-btn x-small value="MXN" style="text-transform: none; font-family: 'montserrat-medium'; font-size: 11px;">MXN</v-btn>
                      </v-btn-toggle>
                    </div>
                    <v-text-field
                      v-model="form.sInOutRate"
                      type="number"
                      step="0.01"
                      placeholder="0.00"
                      outlined
                      dense
                      hide-details
                      style="border-radius: 10px;"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Otros Costos (oculto si override activo) -->
                <div class="mb-3">
                  <div class="d-flex align-center justify-space-between mb-2">
                    <div style="font-family: 'montserrat-medium'; font-size: 13px; color: #555;">
                      <v-icon x-small color="#d97706" class="mr-1">mdi-playlist-plus</v-icon>
                      Otros Costos
                    </div>
                    <v-btn x-small text color="#d97706" @click="addOtherCost" style="text-transform: none; font-family: 'montserrat-medium'; font-size: 11px;">
                      <v-icon x-small left>mdi-plus</v-icon>
                      Agregar
                    </v-btn>
                  </div>
                  <div v-if="otherCosts.length === 0" style="font-family: 'montserrat-regular'; font-size: 12px; color: #9E9E9E;" class="mb-1 ml-1">
                    Sin costos adicionales
                  </div>
                  <div v-for="(cost, idx) in otherCosts" :key="idx" class="mb-2">
                    <v-row dense align="center">
                      <v-col cols="4">
                        <v-text-field
                          v-model="cost.name"
                          placeholder="Descripción"
                          outlined
                          dense
                          hide-details
                          style="border-radius: 10px;"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                        <v-text-field
                          v-model="cost.amount"
                          type="number"
                          step="0.01"
                          placeholder="0.00"
                          outlined
                          dense
                          hide-details
                          style="border-radius: 10px;"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-btn-toggle v-model="cost.currency" mandatory dense class="currency-toggle">
                          <v-btn x-small value="USD" style="text-transform: none; font-family: 'montserrat-medium'; font-size: 11px;">USD</v-btn>
                          <v-btn x-small value="MXN" style="text-transform: none; font-family: 'montserrat-medium'; font-size: 11px;">MXN</v-btn>
                        </v-btn-toggle>
                      </v-col>
                      <v-col cols="1" class="pa-0">
                        <v-btn icon x-small @click="removeOtherCost(idx)">
                          <v-icon small color="#9E9E9E">mdi-close</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </div>
                </div>

                <!-- Tipo de Cambio -->
                <v-row dense class="mb-2">
                  <v-col cols="12">
                    <div class="d-flex align-center justify-space-between mb-1">
                      <div style="font-family: 'montserrat-medium'; font-size: 13px; color: #555;">
                        <v-icon x-small color="#2563eb" class="mr-1">mdi-swap-horizontal</v-icon>
                        Tipo de Cambio (MXN por 1 USD)
                      </div>
                      <span v-if="fetchingRate" style="font-family: 'montserrat-regular'; font-size: 11px; color: #9E9E9E;">
                        <v-progress-circular indeterminate size="10" width="1" color="#9E9E9E" class="mr-1"></v-progress-circular>
                        Obteniendo TC...
                      </span>
                    </div>
                    <v-text-field
                      v-model="form.dRatePerUSD"
                      type="number"
                      step="0.0001"
                      :placeholder="ratePlaceholder"
                      outlined
                      dense
                      hide-details
                      style="border-radius: 10px;"
                    ></v-text-field>
                    <div v-if="rateHint" style="font-family: 'montserrat-regular'; font-size: 11px; color: #9E9E9E;" class="mt-1 ml-1">
                      1 USD = {{ ratePlaceholder }} MXN
                    </div>
                  </v-col>
                </v-row>

                <!-- Notas -->
                <div class="mb-4">
                  <div style="font-family: 'montserrat-medium'; font-size: 13px; color: #555;" class="mb-1">
                    <v-icon x-small color="#6b7280" class="mr-1">mdi-note-text</v-icon>
                    Notas
                  </div>
                  <v-textarea
                    v-model="form.notes"
                    placeholder="Agrega notas o comentarios..."
                    outlined
                    dense
                    rows="2"
                    hide-details
                    style="border-radius: 10px;"
                  ></v-textarea>
                </div>

                <!-- ===== RESULTADO INTEGRADO ===== -->
                <!-- Aviso: falta tipo de cambio -->
                <div v-if="needsExchangeRate && !hasValidExchangeRate && hasEnoughDataForAlert"
                  class="pa-4 mb-4 d-flex align-center" style="background-color: #FFF3E0; border: 1px solid #FFB74D; border-radius: 12px;">
                  <v-icon color="#E65100" class="mr-3">mdi-alert-circle</v-icon>
                  <div>
                    <div style="font-family: 'montserrat-semibold'; font-size: 13px; color: #E65100;">Tipo de cambio requerido</div>
                    <div style="font-family: 'montserrat-regular'; font-size: 12px; color: #BF360C;">Ingresa el tipo de cambio (MXN por 1 USD) para calcular los resultados.</div>
                  </div>
                </div>

                <!-- Resumen de resultado en columna de Datos Numéricos -->
                <div class="mb-4 pa-5 text-center" style="background-color: #000000; border-radius: 16px; color: #fff;">
                  <div style="font-family: 'montserrat-medium'; font-size: 14px;" class="mb-1">
                    {{ calcMode === 'cost' ? 'Precio FOB sin Margen' : 'Máximo a Pagar' }}
                  </div>
                  <div style="font-family: 'montserrat-bold'; font-size: 32px;">
                    <template v-if="calcMode === 'cost'">
                      {{ formatCurrency(currentFobSellPrice) }}
                    </template>
                    <template v-else-if="calcMode === 'maxpay'">
                      {{ new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }).format(appliedMaxPayPrice !== null ? appliedMaxPayPrice : maxPayMXN) }}
                    </template>
                    <template v-else>
                      $0.00
                    </template>
                  </div>
                  <div style="font-family: 'montserrat-regular'; font-size: 12px; opacity: 0.85;" class="mt-1">
                    {{ calcMode === 'cost' ? 'USD / caja' : 'MXN / caja' }}
                  </div>
                </div>
              </v-col>
              <!-- ===== COLUMNA IZQUIERDA: Opciones ===== -->
              <v-col cols="12" lg="6" order="1">
                <div class="d-flex align-center mb-4">
                  <v-icon color="#1d4ed8" class="mr-2">mdi-cog</v-icon>
                  <span style="font-family: 'montserrat-bold'; font-size: 16px; color: #000000;">
                    Opciones de Cálculo
                  </span>
                </div>

                <!-- Modo de Cálculo -->
                <div style="font-family: 'montserrat-medium'; font-size: 16px; color: #333;" class="mb-1">
                  ¿Qué quiero calcular?
                </div>
                <v-row dense class="mb-3">
                  <v-col cols="6">
                    <v-card
                      @click="calcMode = 'cost'"
                      :style="calcMode === 'cost'
                        ? 'border: 2px solid #000000; background-color: #F0F0F0;'
                        : 'border: 2px solid #E0E0E0;'"
                      style="border-radius: 10px; cursor: pointer; padding: 8px 12px;"
                      elevation="0"
                    >
                      <v-icon :color="calcMode === 'cost' ? '#000000' : '#9E9E9E'" size="20" class="mr-1">mdi-calculator-variant</v-icon>
                      <div class="mt-1">
                        <div :style="calcMode === 'cost' ? 'color: #000000;' : 'color: #757575;'" style="font-family: 'montserrat-semibold'; font-size: 12px; line-height: 1.3;">
                          ¿Cuánto me cuesta?
                        </div>
                        <div style="font-family: 'montserrat-regular'; font-size: 14px; color: #9E9E9E; line-height: 1.2;">
                          Precio MXN → FOB USD
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="6">
                    <v-card
                      @click="calcMode = 'maxpay'"
                      :style="calcMode === 'maxpay'
                        ? 'border: 2px solid #000000; background-color: #F0F0F0;'
                        : 'border: 2px solid #E0E0E0;'"
                      style="border-radius: 10px; cursor: pointer; padding: 8px 12px;"
                      elevation="0"
                    >
                      <v-icon :color="calcMode === 'maxpay' ? '#000000' : '#9E9E9E'" size="20" class="mr-1">mdi-currency-usd</v-icon>
                      <div class="mt-1">
                        <div :style="calcMode === 'maxpay' ? 'color: #000000;' : 'color: #757575;'" style="font-family: 'montserrat-semibold'; font-size: 12px; line-height: 1.3;">
                          ¿Cuánto puedo pagar?
                        </div>
                        <div style="font-family: 'montserrat-regular'; font-size: 14px; color: #9E9E9E; line-height: 1.2;">
                          Precio mercado → max MXN
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <!-- Unidad de Medida -->
                <div style="font-family: 'montserrat-medium'; font-size: 16px; color: #333;" class="mb-1">
                  Unidad de Medida
                </div>
                <v-row dense class="mb-3">
                  <v-col cols="6">
                    <v-card
                      @click="unit = 'boxes'"
                      :style="unit === 'boxes'
                        ? 'border: 2px solid #ea580c; background-color: #FFF7ED;'
                        : 'border: 2px solid #E0E0E0;'"
                      style="border-radius: 10px; cursor: pointer; padding: 8px 12px;"
                      elevation="0"
                      class="d-flex align-center py-5"
                    >
                      <v-icon :color="unit === 'boxes' ? '#ea580c' : '#9E9E9E'" size="20" class="mr-2">mdi-package-variant</v-icon>
                      <div>
                        <div :style="unit === 'boxes' ? 'color: #ea580c;' : 'color: #757575;'" style="font-family: 'montserrat-semibold'; font-size: 16px; line-height: 1.2;">
                          Cajas
                        </div>
                        <div style="font-family: 'montserrat-regular'; font-size: 14px; color: #9E9E9E; line-height: 1.2;">
                          Ingreso total directo
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                  <v-col cols="6">
                    <v-card
                      @click="unit = 'pallets'"
                      :style="unit === 'pallets'
                        ? 'border: 2px solid #9333ea; background-color: #FAF5FF;'
                        : 'border: 2px solid #E0E0E0;'"
                      style="border-radius: 10px; cursor: pointer; padding: 8px 12px;"
                      elevation="0"
                      class="d-flex align-center py-5"
                    >
                      <v-icon :color="unit === 'pallets' ? '#9333ea' : '#9E9E9E'" size="20" class="mr-2">mdi-shipping-pallet</v-icon>
                      <div>
                        <div :style="unit === 'pallets' ? 'color: #9333ea;' : 'color: #757575;'" style="font-family: 'montserrat-semibold'; font-size: 16px; line-height: 1.2;">
                          Pallets
                        </div>
                        <div style="font-family: 'montserrat-regular'; font-size: 14px; color: #9E9E9E; line-height: 1.2;">
                          Cajas por pallet x pallets
                        </div>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>

                <div class="pa-3 mb-3" style="background-color: #FFF8E1; border-radius: 10px; border: 1px solid #FFE082;">
                  <v-switch
                    v-model="useLogisticsOverride"
                    label="Usar costo logístico manual"
                    dense
                    hide-details
                    color="#F9A825"
                    class="mt-0"
                  ></v-switch>
                  <div style="font-family: 'montserrat-regular'; font-size: 11px; color: #757575;" class="ml-12">
                    Reemplaza el cálculo automático por un valor fijo
                  </div>
                  <div v-if="useLogisticsOverride" class="mt-3">
                    <div class="d-flex align-center justify-space-between mb-1">
                      <div style="font-family: 'montserrat-medium'; font-size: 13px; color: #555;">
                        Costo Logístico por Caja
                      </div>
                      <v-btn-toggle v-model="currencies.logisticsCost" mandatory dense class="currency-toggle">
                        <v-btn x-small value="USD" style="text-transform: none; font-family: 'montserrat-medium'; font-size: 11px;">USD</v-btn>
                        <v-btn x-small value="MXN" style="text-transform: none; font-family: 'montserrat-medium'; font-size: 11px;">MXN</v-btn>
                      </v-btn-toggle>
                    </div>
                    <v-text-field
                      v-model="form.dLogisticsCostOverride"
                      type="number"
                      step="0.01"
                      placeholder="0.00"
                      outlined
                      dense
                      hide-details
                      style="border-radius: 10px;"
                    ></v-text-field>
                  </div>
                </div>
                <!-- Tipo de Producto -->
                <div class="mb-4">
                  <div style="font-family: 'montserrat-medium'; font-size: 13px; color: #333;" class="mb-2">
                    Tipo de Producto
                  </div>
                  <v-select
                    v-model="productType"
                    :items="productTypes"
                    item-text="text"
                    item-value="value"
                    outlined
                    dense
                    hide-details
                    style="border-radius: 10px;"
                  >
                    <template v-slot:item="{ item }">
                      <v-icon :color="item.color" small class="mr-2">{{ item.icon }}</v-icon>
                      {{ item.text }}
                    </template>
                    <template v-slot:selection="{ item }">
                      <v-icon :color="item.color" small class="mr-2">{{ item.icon }}</v-icon>
                      {{ item.text }}
                    </template>
                  </v-select>
                </div>

                <!-- Resultados: Modo cost -->
                <div v-if="calcMode === 'cost'">
                  <div class="mb-4 pa-5 text-center" style="background-color: #000000; border-radius: 16px; color: #fff;">
                    <div class="d-flex align-center justify-center mb-2">
                      <v-icon color="white" class="mr-2">mdi-trending-up</v-icon>
                      <span style="font-family: 'montserrat-medium'; font-size: 14px;">Precio FOB sin Margen</span>
                    </div>
                    <div v-if="!showFobEdit" class="d-flex align-center justify-center">
                      <span style="font-family: 'montserrat-bold'; font-size: 36px;">{{ formatCurrency(currentFobSellPrice) }}</span>
                      <v-btn icon dark x-small class="ml-2" @click="startFobEdit" style="margin-top: -4px;">
                        <v-icon small color="rgba(255,255,255,0.5)">mdi-pencil</v-icon>
                      </v-btn>
                    </div>
                    <div v-else class="d-flex align-center justify-center">
                      <span style="font-family: 'montserrat-bold'; font-size: 36px; color: rgba(255,255,255,0.5);">$</span>
                      <input
                        ref="fobEditInput"
                        type="number"
                        step="0.01"
                        v-model="fobEditPrice"
                        :placeholder="currentFobSellPrice.toString()"
                        @keyup.enter="applyFobEdit"
                        style="font-family: 'montserrat-bold'; font-size: 36px; color: #fff; background: transparent; border: none; border-bottom: 2px dashed rgba(255,255,255,0.3); text-align: center; width: 180px; outline: none; -moz-appearance: textfield;"
                      />
                      <v-btn icon dark x-small class="ml-1" @click="applyFobEdit" style="margin-top: -4px;">
                        <v-icon small color="rgba(255,255,255,0.5)">mdi-check</v-icon>
                      </v-btn>
                    </div>
                    <!-- Preview precio unitario al editar FOB -->
                    <div v-if="showFobEdit && fobEditPrice !== '' && parseFloat(fobEditPrice) > 0" class="mt-1 text-center">
                      <span style="font-family: 'montserrat-bold'; font-size: 14px;" :style="{ color: fobEditDiff >= 0 ? '#81C784' : '#EF9A9A' }">
                        {{ fobEditDiff >= 0 ? '+' : '' }}{{ fobEditDiffPercent }}%
                      </span>
                      <span style="font-family: 'montserrat-regular'; font-size: 12px; opacity: 0.6; margin-left: 4px;">
                        ({{ fobEditDiff >= 0 ? '+' : '' }}{{ formatCurrency(fobEditDiff) }})
                      </span>
                      <div style="font-family: 'montserrat-regular'; font-size: 11px; opacity: 0.75;" class="mt-1">
                        Precio unitario estimado: <strong>{{ fobEditUnitPricePreview.toFixed(2) }} {{ currencies.unitPrice }}</strong>
                        <span :style="{ color: fobEditUnitPriceDiff >= 0 ? '#81C784' : '#EF9A9A' }">
                          ({{ fobEditUnitPriceDiff >= 0 ? '+' : '' }}{{ fobEditUnitPriceDiff.toFixed(2) }})
                        </span>
                      </div>
                    </div>
                    <div v-else-if="appliedSellPrice !== null" class="mt-1 text-center">
                      <span style="font-family: 'montserrat-bold'; font-size: 14px;" :style="{ color: currentFobDiff >= 0 ? '#81C784' : '#EF9A9A' }">
                        {{ currentFobDiff >= 0 ? '+' : '' }}{{ currentFobDiffPercent }}%
                      </span>
                      <span style="font-family: 'montserrat-regular'; font-size: 12px; opacity: 0.6; margin-left: 4px;">
                        ({{ currentFobDiff >= 0 ? '+' : '' }}{{ formatCurrency(currentFobDiff) }})
                      </span>
                      <div style="font-family: 'montserrat-regular'; font-size: 11px; opacity: 0.75;" class="mt-1">
                        Precio unitario estimado: <strong>{{ currentFobUnitPricePreview.toFixed(2) }} {{ currencies.unitPrice }}</strong>
                        <span :style="{ color: currentFobUnitPriceDiff >= 0 ? '#81C784' : '#EF9A9A' }">
                          ({{ currentFobUnitPriceDiff >= 0 ? '+' : '' }}{{ currentFobUnitPriceDiff.toFixed(2) }})
                        </span>
                      </div>
                    </div>
                    <div v-else style="font-family: 'montserrat-regular'; font-size: 12px; opacity: 0.85;" class="mt-1">
                      USD / caja
                    </div>
                    <div class="d-flex justify-center mt-3" style="gap: 8px; flex-wrap: wrap;">
                      <v-btn small outlined dark style="border-radius: 20px; font-family: 'montserrat-medium'; text-transform: none; font-size: 11px; border-color: rgba(255,255,255,0.5); height: 30px;" @click="showLiveDetail = true">
                        <v-icon left x-small>mdi-eye</v-icon>
                        Ver Detalle
                      </v-btn>
                      <v-btn small dark style="border-radius: 20px; font-family: 'montserrat-medium'; text-transform: none; font-size: 11px; background-color: rgba(255,255,255,0.2); height: 30px;" @click="handleSave">
                        <v-icon left x-small>mdi-content-save</v-icon>
                        {{ editingId ? 'Actualizar' : 'Guardar' }}
                      </v-btn>
                      <v-btn v-if="editingId" small outlined dark style="border-radius: 20px; font-family: 'montserrat-medium'; text-transform: none; font-size: 11px; border-color: rgba(255,255,255,0.3); height: 30px;" @click="cancelEdit">
                        <v-icon left x-small>mdi-close</v-icon>
                        Cancelar
                      </v-btn>
                      <v-btn small outlined dark style="border-radius: 20px; font-family: 'montserrat-medium'; text-transform: none; font-size: 11px; border-color: rgba(255,255,255,0.3); height: 30px;" @click="handleReset">
                        <v-icon left x-small>mdi-refresh</v-icon>
                        Limpiar
                      </v-btn>
                    </div>
                  </div>
                </div>

                <!-- Resultados: Modo maxpay -->
                <div v-else-if="calcMode === 'maxpay'">
                  <div class="mb-4 pa-5 text-center" style="background-color: #000000; border-radius: 16px; color: #fff;">
                    <div class="d-flex align-center justify-center mb-2">
                      <v-icon color="white" class="mr-2">mdi-currency-usd</v-icon>
                      <span style="font-family: 'montserrat-medium'; font-size: 14px;">Máximo a Pagar</span>
                    </div>
                    <div v-if="!showMaxPayEdit" class="d-flex align-center justify-center">
                      <span style="font-family: 'montserrat-bold'; font-size: 36px;">
                        {{ new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }).format(appliedMaxPayPrice !== null ? appliedMaxPayPrice : maxPayMXN) }}
                      </span>
                      <v-btn icon dark x-small class="ml-2" @click="startMaxPayEdit" style="margin-top: -4px;">
                        <v-icon small color="rgba(255,255,255,0.5)">mdi-pencil</v-icon>
                      </v-btn>
                    </div>
                    <div v-else class="d-flex align-center justify-center">
                      <span style="font-family: 'montserrat-bold'; font-size: 36px; color: rgba(255,255,255,0.5);">$</span>
                      <input
                        ref="maxPayEditInput"
                        type="number"
                        step="0.01"
                        v-model="maxPayEditPrice"
                        :placeholder="maxPayMXN.toString()"
                        @keyup.enter="applyMaxPayEdit"
                        style="font-family: 'montserrat-bold'; font-size: 36px; color: #fff; background: transparent; border: none; border-bottom: 2px dashed rgba(255,255,255,0.3); text-align: center; width: 200px; outline: none; -moz-appearance: textfield;"
                      />
                      <v-btn icon dark x-small class="ml-1" @click="applyMaxPayEdit" style="margin-top: -4px;">
                        <v-icon small color="rgba(255,255,255,0.5)">mdi-check</v-icon>
                      </v-btn>
                    </div>
                    <!-- Preview al editar maxpay -->
                    <div v-if="showMaxPayEdit && maxPayEditPrice !== '' && parseFloat(maxPayEditPrice) > 0" class="mt-1 text-center">
                      <span style="font-family: 'montserrat-bold'; font-size: 14px;" :style="{ color: maxPayEditDiff >= 0 ? '#81C784' : '#EF9A9A' }">
                        {{ maxPayEditDiff >= 0 ? '+' : '' }}{{ maxPayEditDiffPercent }}%
                      </span>
                      <span style="font-family: 'montserrat-regular'; font-size: 12px; opacity: 0.6; margin-left: 4px;">
                        ({{ maxPayEditDiff >= 0 ? '+' : '' }}{{ new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }).format(maxPayEditDiff) }})
                      </span>
                      <div style="font-family: 'montserrat-regular'; font-size: 11px; opacity: 0.75;" class="mt-1">
                        Nuevo disponible para producto: <strong>{{ maxPayEditAvailablePreview.toFixed(2) }} USD/caja</strong>
                        <span :style="{ color: maxPayEditAvailableDiff <= 0 ? '#81C784' : '#EF9A9A' }">
                          ({{ maxPayEditAvailableDiff > 0 ? '+' : '' }}{{ maxPayEditAvailableDiff.toFixed(2) }})
                        </span>
                      </div>
                    </div>
                    <div v-else-if="!showMaxPayEdit">
                      <div style="font-family: 'montserrat-regular'; font-size: 12px; opacity: 0.75;" class="mt-1">
                        MXN / caja
                      </div>
                      <div v-if="appliedMaxPayPrice !== null && appliedMaxPayPrice !== maxPayMXN" style="font-family: 'montserrat-regular'; font-size: 11px; opacity: 0.6;" class="mt-1">
                        Calculado: {{ new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }).format(maxPayMXN) }}
                      </div>
                      <div style="font-family: 'montserrat-regular'; font-size: 11px; opacity: 0.6;" class="mt-1">
                        Disponible para producto: {{ formatCurrency(availableForProduct) }} USD/caja
                      </div>
                    </div>
                    <div class="d-flex justify-center mt-3" style="gap: 8px; flex-wrap: wrap;">
                      <v-btn small outlined dark style="border-radius: 20px; font-family: 'montserrat-medium'; text-transform: none; font-size: 11px; border-color: rgba(255,255,255,0.5); height: 30px;" @click="showLiveDetail = true">
                        <v-icon left x-small>mdi-eye</v-icon>
                        Ver Detalle
                      </v-btn>
                      <v-btn small dark style="border-radius: 20px; font-family: 'montserrat-medium'; text-transform: none; font-size: 11px; background-color: rgba(255,255,255,0.2); height: 30px;" @click="handleSave">
                        <v-icon left x-small>mdi-content-save</v-icon>
                        {{ editingId ? 'Actualizar' : 'Guardar' }}
                      </v-btn>
                      <v-btn v-if="editingId" small outlined dark style="border-radius: 20px; font-family: 'montserrat-medium'; text-transform: none; font-size: 11px; border-color: rgba(255,255,255,0.3); height: 30px;" @click="cancelEdit">
                        <v-icon left x-small>mdi-close</v-icon>
                        Cancelar
                      </v-btn>
                      <v-btn small outlined dark style="border-radius: 20px; font-family: 'montserrat-medium'; text-transform: none; font-size: 11px; border-color: rgba(255,255,255,0.3); height: 30px;" @click="handleReset">
                        <v-icon left x-small>mdi-refresh</v-icon>
                        Limpiar
                      </v-btn>
                    </div>
                  </div>
                </div>

                <!-- Estado vacío -->
                <div v-else class="pa-8 text-center" style="border-radius: 16px; border: 2px dashed #c5cdd3;">
                  <v-icon size="48" color="#c5cdd3">mdi-calculator-variant</v-icon>
                  <div style="font-family: 'montserrat-medium'; font-size: 14px; color: #9E9E9E;" class="mt-3">
                    Ingresa los datos para ver el resultado
                  </div>
                </div>

              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>

        <!-- ==================== TAB HISTORIAL ==================== -->
        <v-tab-item>
          <v-card v-if="calculations.length === 0" class="pa-12 text-center" style="border-radius: 16px; border: 1px solid #c5cdd3;" elevation="0">
            <v-icon size="64" color="#c5cdd3">mdi-package-variant</v-icon>
            <div style="font-family: 'montserrat-semibold'; font-size: 18px; color: #555;" class="mt-4">
              Sin cálculos guardados
            </div>
            <div style="font-family: 'montserrat-regular'; font-size: 14px; color: #9E9E9E;" class="mt-2">
              Los cálculos que guardes aparecerán aquí
            </div>
          </v-card>

          <v-card v-else style="border-radius: 16px; border: 1px solid #c5cdd3; overflow: hidden;" elevation="2">
            <v-data-table
              :headers="historyHeaders"
              :items="calculations"
              :items-per-page="10"
              class="elevation-0"
            >
              <template v-slot:item.date="{ item }">
                <span style="font-family: 'montserrat-regular'; font-size: 13px;">{{ formatDate(item.date) }}</span>
              </template>
              <template v-slot:item.type="{ item }">
                <v-chip x-small color="#F5F5F5" text-color="#555" style="font-family: 'montserrat-medium';">
                  <v-icon x-small left>{{ (item.calcMode || item.type) === 'maxpay' ? 'mdi-currency-usd' : 'mdi-calculator-variant' }}</v-icon>
                  {{ (item.calcMode || item.type) === 'maxpay' ? 'Max. Pagar' : 'Costo' }}
                </v-chip>
              </template>
              <template v-slot:item.productType="{ item }">
                <div class="d-flex align-center">
                  <v-icon small :color="item.productType === 'fruits' ? '#16a34a' : item.productType === 'vegetables' ? '#ea580c' : '#2563eb'" class="mr-1">
                    {{ item.productType === 'fruits' ? 'mdi-food-apple' : item.productType === 'vegetables' ? 'mdi-carrot' : 'mdi-package-variant' }}
                  </v-icon>
                  <span style="font-family: 'montserrat-regular'; font-size: 13px;">
                    {{ item.productType === 'fruits' ? 'Frutas' : item.productType === 'vegetables' ? 'Verduras' : 'Mixto' }}
                  </span>
                </div>
              </template>
              <template v-slot:item.totalBoxes="{ item }">
                <span style="font-family: 'montserrat-semibold';">{{ item.totalBoxes }}</span>
              </template>
              <template v-slot:item.tc="{ item }">
                <div v-if="item.form && item.form.dRatePerUSD" class="text-center">
                  <div style="font-family: 'montserrat-semibold'; font-size: 13px;">{{ parseFloat(item.form.dRatePerUSD).toFixed(4) }}</div>
                  <div v-if="ratePlaceholder && parseFloat(ratePlaceholder) > 0">
                    <span
                      style="font-family: 'montserrat-medium'; font-size: 11px;"
                      :style="{ color: parseFloat(ratePlaceholder) > parseFloat(item.form.dRatePerUSD) ? '#16a34a' : parseFloat(ratePlaceholder) < parseFloat(item.form.dRatePerUSD) ? '#dc2626' : '#9E9E9E' }"
                    >
                      {{ parseFloat(ratePlaceholder) > parseFloat(item.form.dRatePerUSD) ? '▲' : parseFloat(ratePlaceholder) < parseFloat(item.form.dRatePerUSD) ? '▼' : '=' }}
                      {{ (((parseFloat(ratePlaceholder) - parseFloat(item.form.dRatePerUSD)) / parseFloat(item.form.dRatePerUSD)) * 100).toFixed(2) }}%
                    </span>
                  </div>
                </div>
                <span v-else style="font-family: 'montserrat-regular'; font-size: 12px; color: #9E9E9E;">—</span>
              </template>
              <template v-slot:item.sellPrice="{ item }">
                <!-- modo maxpay: siempre muestra Venta (appliedMaxPayPrice) y Costo (maxPayMXN calculado) -->
                <div v-if="(item.calcMode || item.type) === 'maxpay'" class="text-right">
                  <div
                    style="font-family: 'montserrat-bold';"
                    :style="{ color: (item.appliedMaxPayPrice != null ? item.appliedMaxPayPrice : (item.maxPayMXN || 0)) <= (item.maxPayMXN || 0) ? '#16a34a' : '#dc2626' }"
                  >
                    Venta: {{ new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }).format(item.appliedMaxPayPrice != null ? item.appliedMaxPayPrice : (item.maxPayMXN || 0)) }}
                  </div>
                  <div style="font-family: 'montserrat-regular'; font-size: 11px; color: #9E9E9E;">
                    Costo: {{ new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }).format(item.maxPayMXN || 0) }}
                  </div>
                </div>
                <!-- modo cost: siempre muestra Venta (appliedSellPrice) y Costo (priceFOBWithoutMargin calculado) -->
                <div v-else class="text-right">
                  <div
                    style="font-family: 'montserrat-bold';"
                    :style="{ color: (item.appliedSellPrice != null ? item.appliedSellPrice : (item.priceFOBWithoutMargin || 0)) >= (item.priceFOBWithoutMargin || 0) ? '#16a34a' : '#dc2626' }"
                  >
                    Venta: {{ formatCurrency(item.appliedSellPrice != null ? item.appliedSellPrice : (item.priceFOBWithoutMargin || 0)) }}
                  </div>
                  <div style="font-family: 'montserrat-regular'; font-size: 11px; color: #9E9E9E;">
                    Costo: {{ formatCurrency(item.priceFOBWithoutMargin || 0) }}
                  </div>
                </div>
              </template>
              <template v-slot:item.actions="{ item }">
                <div class="d-flex justify-center" style="gap: 4px;">
                  <v-btn icon x-small @click="openCalculationDetail(item)">
                    <v-icon small color="#000000">mdi-eye</v-icon>
                  </v-btn>
                  <v-btn icon x-small @click="editCalculation(item)">
                    <v-icon small color="#333333">mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn icon x-small @click="deleteTarget = item.id">
                    <v-icon small color="#F44336">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-container>

    <!-- ===== DIALOG: Confirmar eliminación ===== -->
    <v-dialog v-model="showDeleteDialog" max-width="400">
      <v-card style="border-radius: 16px;">
        <v-card-title style="font-family: 'montserrat-bold';">Eliminar cálculo</v-card-title>
        <v-card-text style="font-family: 'montserrat-regular';">¿Estás seguro de que deseas eliminar este cálculo?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteTarget = null" style="text-transform: none; font-family: 'montserrat-medium';">Cancelar</v-btn>
          <v-btn color="#F44336" class="white--text" @click="confirmDelete" style="text-transform: none; font-family: 'montserrat-semibold'; border-radius: 20px;">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- ===== DIALOG: Ver detalle guardado ===== -->
    <v-dialog v-model="showViewDialog" max-width="600">
      <v-card v-if="viewCalculation" style="border-radius: 16px; height: fit-content">
        <v-card-title style="font-family: 'montserrat-bold'; color: #000000;">
          Detalle del Cálculo
          <v-spacer></v-spacer>
          <v-btn icon @click="viewCalculation = null"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row class="mb-3">
            <v-col cols="6">
              <div style="font-family: 'montserrat-regular'; font-size: 12px; color: #9E9E9E;">Fecha</div>
              <div style="font-family: 'montserrat-medium';">{{ formatDate(viewCalculation.date) }}</div>
            </v-col>
            <v-col cols="6">
              <div style="font-family: 'montserrat-regular'; font-size: 12px; color: #9E9E9E;">Modo</div>
              <v-chip small color="#F5F5F5" text-color="#555">
                {{ (viewCalculation.calcMode || viewCalculation.type) === 'maxpay' ? '¿Cuánto puedo pagar?' : '¿Cuánto me cuesta?' }}
              </v-chip>
            </v-col>
          </v-row>
          <v-divider class="mb-3"></v-divider>

          <!-- Inputs del cálculo -->
          <div class="pa-3 mb-3" style="background-color: #F5F5F5; border-radius: 10px;">
            <div v-if="(viewCalculation.calcMode || viewCalculation.type) === 'maxpay'" class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Precio de Mercado</span>
              <span style="font-family: 'montserrat-medium';">{{ viewCalculation.form.bMarketPrice || '—' }} USD</span>
            </div>
            <div v-else class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Precio Unitario por Caja</span>
              <span style="font-family: 'montserrat-medium';">{{ viewCalculation.form.dUnitPrice }} {{ viewCalculation.currencies.unitPrice }}</span>
            </div>
            <div class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Cajas por Pallet x Total Pallets</span>
              <span style="font-family: 'montserrat-medium';">{{ viewCalculation.form.dBoxesPerPallet }} x {{ viewCalculation.form.sTotalPallets }} = {{ viewCalculation.totalBoxes }}</span>
            </div>
            <div class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Flete</span>
              <span style="font-family: 'montserrat-medium';">{{ viewCalculation.form.dFreight }} {{ viewCalculation.currencies.freight }}</span>
            </div>
            <div class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Costo Aduanal</span>
              <span style="font-family: 'montserrat-medium';">{{ viewCalculation.form.sCustomsFee }} {{ viewCalculation.currencies.customsFee }}</span>
            </div>
            <div v-if="viewCalculation.otherCosts && viewCalculation.otherCosts.length > 0">
              <div v-for="(oc, i) in viewCalculation.otherCosts" :key="i" class="d-flex justify-space-between mb-1">
                <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">{{ oc.name || 'Otro costo' }}</span>
                <span style="font-family: 'montserrat-medium';">{{ oc.amount }} {{ oc.currency }}</span>
              </div>
            </div>
            <div class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Tarifa In/Out por Pallet</span>
              <span style="font-family: 'montserrat-medium';">{{ viewCalculation.form.sInOutRate }} {{ viewCalculation.currencies.inOutRate }}</span>
            </div>
            <div class="d-flex justify-space-between align-center">
              <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Tipo de Cambio (guardado)</span>
              <div class="d-flex align-center" style="gap: 6px;">
                <span style="font-family: 'montserrat-medium';">{{ parseFloat(viewCalculation.form.dRatePerUSD).toFixed(4) }}</span>
                <span
                  v-if="ratePlaceholder && parseFloat(ratePlaceholder) > 0"
                  style="font-family: 'montserrat-medium'; font-size: 11px; padding: 1px 6px; border-radius: 10px;"
                  :style="{
                    color: parseFloat(ratePlaceholder) > parseFloat(viewCalculation.form.dRatePerUSD) ? '#16a34a' : parseFloat(ratePlaceholder) < parseFloat(viewCalculation.form.dRatePerUSD) ? '#dc2626' : '#9E9E9E',
                    backgroundColor: parseFloat(ratePlaceholder) > parseFloat(viewCalculation.form.dRatePerUSD) ? '#F0FDF4' : parseFloat(ratePlaceholder) < parseFloat(viewCalculation.form.dRatePerUSD) ? '#FEF2F2' : '#F5F5F5'
                  }"
                >
                  TC hoy: {{ parseFloat(ratePlaceholder).toFixed(4) }}
                  ({{ parseFloat(ratePlaceholder) >= parseFloat(viewCalculation.form.dRatePerUSD) ? '+' : '' }}{{ (((parseFloat(ratePlaceholder) - parseFloat(viewCalculation.form.dRatePerUSD)) / parseFloat(viewCalculation.form.dRatePerUSD)) * 100).toFixed(2) }}%)
                </span>
              </div>
            </div>
          </div>

          <!-- Resultados -->
          <div class="pa-4 mb-3" style="background-color: #F5F5F5; border-radius: 10px;">
            <div style="font-family: 'montserrat-semibold'; font-size: 13px; color: #333333;" class="mb-2">Desglose Logístico</div>
            <div class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 12px; color: #555;">In/Out por Caja</span>
              <span style="font-family: 'montserrat-medium'; font-size: 12px;">{{ formatCurrency(viewCalculation.inOutPerBox) }}</span>
            </div>
            <div class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 12px; color: #555;">Aduanal por Caja</span>
              <span style="font-family: 'montserrat-medium'; font-size: 12px;">{{ formatCurrency(viewCalculation.customsPerBox) }}</span>
            </div>
            <div class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 12px; color: #555;">Flete por Caja</span>
              <span style="font-family: 'montserrat-medium'; font-size: 12px;">{{ formatCurrency(viewCalculation.freightPerBox) }}</span>
            </div>
            <v-divider class="my-2"></v-divider>
            <div class="d-flex justify-space-between">
              <span style="font-family: 'montserrat-semibold'; font-size: 12px; color: #333;">Costo Logístico / Caja</span>
              <span style="font-family: 'montserrat-bold'; font-size: 12px; color: #000000;">{{ formatCurrency(viewCalculation.logisticsCostPerBox) }}</span>
            </div>
          </div>

          <!-- FOB final (modo cost) -->
          <div v-if="(viewCalculation.calcMode || viewCalculation.type) !== 'maxpay'" class="pa-5 text-center" style="background-color: #000000; border-radius: 12px; color: #fff;">
            <div style="font-family: 'montserrat-medium'; font-size: 13px;" class="mb-1">Precio de Venta / caja</div>
            <div style="font-family: 'montserrat-bold'; font-size: 28px;">
              {{ formatCurrency((viewCalculation.appliedSellPrice != null ? viewCalculation.appliedSellPrice : viewCalculation.priceFOBWithoutMargin) || 0) }}
            </div>
            <div v-if="viewCalculation.appliedSellPrice != null && viewCalculation.appliedSellPrice !== viewCalculation.priceFOBWithoutMargin" class="mt-1">
              <span style="font-family: 'montserrat-regular'; font-size: 11px; opacity: 0.6;">
                Costo (FOB sin Margen): {{ formatCurrency(viewCalculation.priceFOBWithoutMargin || 0) }}
              </span>
              <span
                style="font-family: 'montserrat-medium'; font-size: 11px; margin-left: 6px;"
                :style="{ color: viewCalculation.appliedSellPrice >= viewCalculation.priceFOBWithoutMargin ? '#81C784' : '#EF9A9A' }"
              >
                ({{ viewCalculation.appliedSellPrice >= viewCalculation.priceFOBWithoutMargin ? '+' : '' }}{{ viewCalculation.priceFOBWithoutMargin ? (((viewCalculation.appliedSellPrice - viewCalculation.priceFOBWithoutMargin) / viewCalculation.priceFOBWithoutMargin) * 100).toFixed(2) : '0.00' }}%)
              </span>
            </div>
            <div style="font-family: 'montserrat-regular'; font-size: 12px; opacity: 0.75;" class="mt-1">
              Total Camión (FOB): {{ formatCurrency(viewCalculation.totalTruckFOB) }}
            </div>
          </div>
          <!-- Resultado modo maxpay -->
          <div v-else class="pa-5 text-center" style="background-color: #000000; border-radius: 12px; color: #fff;">
            <div style="font-family: 'montserrat-medium'; font-size: 13px;" class="mb-1">Máximo a Pagar</div>
            <div style="font-family: 'montserrat-bold'; font-size: 28px;">
              {{ new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }).format(viewCalculation.appliedMaxPayPrice || viewCalculation.maxPayMXN || 0) }}
            </div>
            <div v-if="viewCalculation.appliedMaxPayPrice && viewCalculation.appliedMaxPayPrice !== viewCalculation.maxPayMXN" class="mt-1">
              <span style="font-family: 'montserrat-regular'; font-size: 11px; opacity: 0.6;">Calculado: {{ new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }).format(viewCalculation.maxPayMXN || 0) }}</span>
              <span
                style="font-family: 'montserrat-medium'; font-size: 11px; margin-left: 6px;"
                :style="{ color: viewCalculation.appliedMaxPayPrice <= viewCalculation.maxPayMXN ? '#81C784' : '#EF9A9A' }"
              >
                ({{ viewCalculation.appliedMaxPayPrice <= viewCalculation.maxPayMXN ? '+' : '' }}{{ (((viewCalculation.maxPayMXN - viewCalculation.appliedMaxPayPrice) / viewCalculation.maxPayMXN) * 100).toFixed(2) }}%)
              </span>
            </div>
            <div style="font-family: 'montserrat-regular'; font-size: 12px; opacity: 0.75;" class="mt-1">
              Disponible: {{ formatCurrency(viewCalculation.availableForProduct || 0) }} USD/caja
            </div>
          </div>

          <div v-if="viewCalculation.notes" class="mt-3">
            <div style="font-family: 'montserrat-semibold'; font-size: 13px;" class="mb-1">Notas</div>
            <div class="pa-3" style="background-color: #F5F5F5; border-radius: 10px; font-family: 'montserrat-regular'; font-size: 13px; color: #555; white-space: pre-wrap;">{{ viewCalculation.notes }}</div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- ===== DIALOG: Ver detalle en vivo ===== -->
    <v-dialog v-model="showLiveDetail" max-width="600" scrollable>
      <v-card style="border-radius: 16px; min-height: 90vh;">
        <v-card-title style="font-family: 'montserrat-bold'; color: #000000;">
          Detalle del Cálculo
          <v-spacer></v-spacer>
          <v-btn icon @click="showLiveDetail = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <v-row class="mb-3">
            <v-col cols="6">
              <div style="font-family: 'montserrat-regular'; font-size: 12px; color: #9E9E9E;">Modo de Cálculo</div>
              <v-chip small color="#F5F5F5" text-color="#555">
                {{ calcMode === 'maxpay' ? '¿Cuánto puedo pagar?' : '¿Cuánto me cuesta?' }}
              </v-chip>
            </v-col>
            <v-col cols="6">
              <div style="font-family: 'montserrat-regular'; font-size: 12px; color: #9E9E9E;">Unidad de Medida</div>
              <v-chip small color="#F5F5F5" text-color="#555">
                {{ unit === 'boxes' ? 'Cajas' : 'Pallets' }}
              </v-chip>
            </v-col>
          </v-row>
          <v-divider class="mb-3"></v-divider>

          <!-- Inputs del cálculo -->
          <div class="pa-3 mb-3" style="background-color: #F5F5F5; border-radius: 10px;">
            <!-- Modo cost -->
            <template v-if="calcMode === 'cost'">
              <div class="d-flex justify-space-between mb-1">
                <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Precio Unitario por Caja</span>
                <span style="font-family: 'montserrat-medium';">{{ form.dUnitPrice }} {{ currencies.unitPrice }}</span>
              </div>
            </template>
            <!-- Modo maxpay -->
            <template v-else>
              <div class="d-flex justify-space-between mb-1">
                <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Precio de Mercado</span>
                <span style="font-family: 'montserrat-medium';">{{ form.bMarketPrice }} USD</span>
              </div>
            </template>
            <div v-if="unit === 'pallets'" class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Cajas por Pallet x Total Pallets</span>
              <span style="font-family: 'montserrat-medium';">{{ form.dBoxesPerPallet }} x {{ form.sTotalPallets }} = {{ dTotalBoxes }}</span>
            </div>
            <div v-else class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Total de Cajas</span>
              <span style="font-family: 'montserrat-medium';">{{ dTotalBoxes }}</span>
            </div>
            <div class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Flete</span>
              <span style="font-family: 'montserrat-medium';">{{ form.dFreight || 0 }} {{ currencies.freight }}</span>
            </div>
            <div class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Costo Aduanal</span>
              <span style="font-family: 'montserrat-medium';">{{ form.sCustomsFee || 0 }} {{ currencies.customsFee }}</span>
            </div>
            <div v-for="(oc, i) in otherCosts" :key="i" class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">{{ oc.name || 'Otro costo ' + (i+1) }}</span>
              <span style="font-family: 'montserrat-medium';">{{ oc.amount || 0 }} {{ oc.currency }}</span>
            </div>
            <div class="d-flex justify-space-between mb-1">
              <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Tarifa In/Out por Pallet</span>
              <span style="font-family: 'montserrat-medium';">{{ form.sInOutRate || 0 }} {{ currencies.inOutRate }}</span>
            </div>
            <div v-if="needsExchangeRate" class="d-flex justify-space-between">
              <span style="font-family: 'montserrat-regular'; font-size: 13px; color: #707070;">Tipo de Cambio</span>
              <span style="font-family: 'montserrat-medium';">{{ form.dRatePerUSD }}</span>
            </div>
          </div>

          <!-- Desglose logístico -->
          <div class="pa-4 mb-3" style="background-color: #F5F5F5; border-radius: 10px;">
            <div style="font-family: 'montserrat-semibold'; font-size: 13px; color: #333333;" class="mb-2">Desglose Logístico</div>
            <template v-if="!useLogisticsOverride">
              <div class="d-flex justify-space-between mb-1">
                <span style="font-family: 'montserrat-regular'; font-size: 12px; color: #555;">In/Out por Caja</span>
                <span style="font-family: 'montserrat-medium'; font-size: 12px;">{{ formatCurrency(inOutPerBox) }}</span>
              </div>
              <div class="d-flex justify-space-between mb-1">
                <span style="font-family: 'montserrat-regular'; font-size: 12px; color: #555;">Aduanal por Caja</span>
                <span style="font-family: 'montserrat-medium'; font-size: 12px;">{{ formatCurrency(customsPerBox) }}</span>
              </div>
              <div class="d-flex justify-space-between mb-1">
                <span style="font-family: 'montserrat-regular'; font-size: 12px; color: #555;">Flete por Caja</span>
                <span style="font-family: 'montserrat-medium'; font-size: 12px;">{{ formatCurrency(freightPerBox) }}</span>
              </div>
              <v-divider class="my-2"></v-divider>
            </template>
            <div class="d-flex justify-space-between">
              <span style="font-family: 'montserrat-semibold'; font-size: 12px; color: #333;">
                Costo Logístico / Caja
                <span v-if="useLogisticsOverride" style="font-size: 11px; color: #F9A825;"> (Manual)</span>
              </span>
              <span style="font-family: 'montserrat-bold'; font-size: 12px; color: #000000;">{{ formatCurrency(logisticsCostPerBox) }}</span>
            </div>
          </div>

          <!-- Desglose del precio (modo cost) -->
          <template v-if="calcMode === 'cost'">
            <div class="pa-4 mb-3" style="background-color: #F8F9FA; border: 1px solid #E0E0E0; border-radius: 10px;">
              <div style="font-family: 'montserrat-semibold'; font-size: 13px; color: #555;" class="mb-2">Desglose del Precio</div>
              <div class="d-flex justify-space-between mb-1">
                <span style="font-family: 'montserrat-regular'; font-size: 12px; color: #707070;">Precio Unitario (USD)</span>
                <span style="font-family: 'montserrat-medium'; font-size: 12px;">{{ formatCurrency(usdUnitPrice) }}</span>
              </div>
              <div class="d-flex justify-space-between mb-1">
                <span style="font-family: 'montserrat-regular'; font-size: 12px; color: #707070;">Logística por Caja</span>
                <span style="font-family: 'montserrat-medium'; font-size: 12px;">+ {{ formatCurrency(logisticsCostPerBox) }}</span>
              </div>
              <v-divider class="my-2"></v-divider>
              <div class="d-flex justify-space-between mb-1">
                <span style="font-family: 'montserrat-medium'; font-size: 12px; color: #555;">Precio FOB sin Margen</span>
                <span style="font-family: 'montserrat-bold'; font-size: 12px;">{{ formatCurrency(priceFOBWithoutMargin) }}</span>
              </div>
            </div>
            <div class="pa-5 text-center" style="background-color: #000000; border-radius: 12px; color: #fff;">
              <div style="font-family: 'montserrat-medium'; font-size: 13px;" class="mb-1">Precio FOB sin Margen</div>
              <div style="font-family: 'montserrat-bold'; font-size: 28px;">{{ formatCurrency(priceFOBWithoutMargin) }}</div>
              <div style="font-family: 'montserrat-regular'; font-size: 12px; opacity: 0.8;" class="mt-1">
                Total Camión (FOB): {{ formatCurrency(totalTruckFOB) }} ({{ dTotalBoxes }} cajas)
              </div>
            </div>
          </template>

          <!-- Desglose del precio (modo maxpay) -->
          <template v-else>
            <div class="pa-4 mb-3" style="background-color: #F8F9FA; border: 1px solid #E0E0E0; border-radius: 10px;">
              <div style="font-family: 'montserrat-semibold'; font-size: 13px; color: #555;" class="mb-2">Desglose del Precio</div>
              <div class="d-flex justify-space-between mb-1">
                <span style="font-family: 'montserrat-regular'; font-size: 12px; color: #707070;">Precio de Mercado (USD)</span>
                <span style="font-family: 'montserrat-medium'; font-size: 12px;">{{ formatCurrency(usdMarketPrice) }}</span>
              </div>
              <div class="d-flex justify-space-between mb-1">
                <span style="font-family: 'montserrat-regular'; font-size: 12px; color: #707070;">Logística por Caja</span>
                <span style="font-family: 'montserrat-medium'; font-size: 12px;">− {{ formatCurrency(logisticsCostPerBox) }}</span>
              </div>
              <v-divider class="my-2"></v-divider>
              <div class="d-flex justify-space-between mb-1">
                <span style="font-family: 'montserrat-medium'; font-size: 12px; color: #555;">Disponible para Producto (USD)</span>
                <span style="font-family: 'montserrat-bold'; font-size: 12px;">{{ formatCurrency(availableForProduct) }}</span>
              </div>
              <div class="d-flex justify-space-between mb-1">
                <span style="font-family: 'montserrat-regular'; font-size: 12px; color: #707070;">× Tipo de Cambio</span>
                <span style="font-family: 'montserrat-medium'; font-size: 12px;">{{ form.dRatePerUSD }}</span>
              </div>
            </div>
            <div class="pa-5 text-center" style="background-color: #000000; border-radius: 12px; color: #fff;">
              <div style="font-family: 'montserrat-medium'; font-size: 13px;" class="mb-1">Máximo a Pagar</div>
              <div style="font-family: 'montserrat-bold'; font-size: 28px;">
                {{ new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN', minimumFractionDigits: 2 }).format(maxPayMXN) }}
              </div>
              <div style="font-family: 'montserrat-regular'; font-size: 12px; opacity: 0.8;" class="mt-1">
                MXN / caja · {{ dTotalBoxes }} cajas
              </div>
            </div>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
var STORAGE_KEY = "proplat-calculator-admin-v2";

function roundFinancial(value, decimals) {
  if (decimals === undefined) decimals = 2;
  var factor = Math.pow(10, decimals);
  var scaled = value * factor;
  var floor = Math.floor(scaled);
  var diff = scaled - floor;

  if (diff > 0.5) return Math.ceil(scaled) / factor;
  if (diff < 0.5) return floor / factor;
  return (floor % 2 === 0 ? floor : floor + 1) / factor;
}

export default {
  name: "ProplatCalculator",
  data() {
    return {
      activeTab: 0,
      editingId: null,
      calcMode: "cost",
      form: {
        dUnitPrice: "",
        bMarketPrice: "",
        dBoxesPerPallet: "40",
        sTotalPallets: "26",
        dTotalBoxesDirect: "1040",
        dFreight: "",
        sCustomsFee: "",
        sInOutRate: "",
        dRatePerUSD: "",
        dLogisticsCostOverride: "",
        notes: "",
      },
      currencies: {
        unitPrice: "MXN",
        freight: "MXN",
        customsFee: "USD",
        inOutRate: "USD",
        logisticsCost: "USD",
      },
      otherCosts: [],
      useLogisticsOverride: false,
      unit: "boxes",
      productType: "fruits",
      calculations: [],
      deleteTarget: null,
      viewCalculation: null,
      showLiveDetail: false,
      fobEditPrice: "",
      showFobEdit: false,
      appliedSellPrice: null,
      maxPayEditPrice: "",
      showMaxPayEdit: false,
      appliedMaxPayPrice: null,
      ratePlaceholder: "17.50",
      rateHint: "",
      fetchingRate: false,
    };
  },
  beforeMount() {
    this.loadCalculations();
    this.fetchExchangeRate();
  },
  computed: {
    productTypes() {
      return [
        { value: "fruits", text: "Frutas", icon: "mdi-food-apple", color: "#16a34a" },
        { value: "vegetables", text: "Verduras", icon: "mdi-carrot", color: "#ea580c" },
        { value: "mixed", text: "Mixto", icon: "mdi-package-variant", color: "#2563eb" },
      ];
    },
    historyHeaders() {
      return [
        { text: "Fecha", value: "date" },
        { text: "Tipo", value: "type" },
        { text: "Producto", value: "productType" },
        { text: "Cajas", value: "totalBoxes" },
        { text: "TC", value: "tc", align: "center" },
        { text: "Venta / Caja", value: "sellPrice", align: "end" },
        { text: "Acciones", value: "actions", sortable: false, align: "center" },
      ];
    },
    dTotalBoxes() {
      if (this.unit === "boxes") {
        return parseFloat(this.form.dTotalBoxesDirect) || 0;
      }
      var boxesPerPallet = parseFloat(this.form.dBoxesPerPallet) || 0;
      var totalPallets = parseFloat(this.form.sTotalPallets) || 0;
      return roundFinancial(boxesPerPallet * totalPallets);
    },
    effectiveBoxesPerPallet() {
      if (this.unit === "boxes") {
        return parseFloat(this.form.dBoxesPerPallet) || 40;
      }
      return parseFloat(this.form.dBoxesPerPallet) || 1;
    },
    usdUnitPrice() {
      var v = parseFloat(this.form.dUnitPrice) || 0;
      var rate = parseFloat(this.form.dRatePerUSD) || 1;
      return this.currencies.unitPrice === "MXN" ? v / rate : v;
    },
    usdMarketPrice() {
      return parseFloat(this.form.bMarketPrice) || 0;
    },
    usdCustomsFee() {
      var v = parseFloat(this.form.sCustomsFee) || 0;
      var rate = parseFloat(this.form.dRatePerUSD) || 1;
      return this.currencies.customsFee === "MXN" ? v / rate : v;
    },
    usdFreight() {
      var v = parseFloat(this.form.dFreight) || 0;
      var rate = parseFloat(this.form.dRatePerUSD) || 1;
      return this.currencies.freight === "MXN" ? v / rate : v;
    },
    usdInOutRate() {
      var v = parseFloat(this.form.sInOutRate) || 0;
      var rate = parseFloat(this.form.dRatePerUSD) || 1;
      return this.currencies.inOutRate === "MXN" ? v / rate : v;
    },
    usdLogisticsOverride() {
      var v = parseFloat(this.form.dLogisticsCostOverride) || 0;
      var rate = parseFloat(this.form.dRatePerUSD) || 1;
      return this.currencies.logisticsCost === "MXN" ? v / rate : v;
    },
    totalOtherCostsUSD() {
      var self = this;
      var rate = parseFloat(this.form.dRatePerUSD) || 1;
      var sum = 0;
      this.otherCosts.forEach(function (oc) {
        var amt = parseFloat(oc.amount) || 0;
        sum += oc.currency === "MXN" ? amt / rate : amt;
      });
      return roundFinancial(sum, 4);
    },
    inOutPerBox() {
      if (this.dTotalBoxes <= 0) return 0;
      var bpp = this.effectiveBoxesPerPallet;

      if (this.unit === "boxes") {
        return roundFinancial((this.usdInOutRate) / this.dTotalBoxes, 2);
      } else {
        return roundFinancial((Math.ceil(this.dTotalBoxes / bpp) * this.usdInOutRate) / this.dTotalBoxes, 2);
      }
    },
    customsPerBox() {
      if (this.dTotalBoxes <= 0) return 0;
      return roundFinancial((this.usdCustomsFee + this.totalOtherCostsUSD) / this.dTotalBoxes, 2);
    },
    freightPerBox() {
      if (this.dTotalBoxes <= 0) return 0;
      return roundFinancial(this.usdFreight / this.dTotalBoxes, 2);
    },
    calculatedLogisticsCost() {
      return roundFinancial(this.inOutPerBox + this.customsPerBox + this.freightPerBox, 2);
    },
    logisticsCostPerBox() {
      if (this.useLogisticsOverride) {
        return roundFinancial(this.usdLogisticsOverride, 2);
      }
      return this.calculatedLogisticsCost;
    },
    availableForProduct() {
      return roundFinancial(this.usdMarketPrice - this.logisticsCostPerBox, 4);
    },
    maxPayMXN() {
      var rate = parseFloat(this.form.dRatePerUSD) || 1;
      return roundFinancial(this.availableForProduct * rate, 2);
    },
    needsExchangeRate() {
      if (this.calcMode === "maxpay") return true;
      var hasMXNOtherCost = this.otherCosts.some(function (oc) { return oc.currency === "MXN"; });
      return this.currencies.unitPrice === "MXN" ||
        this.currencies.freight === "MXN" ||
        this.currencies.customsFee === "MXN" ||
        this.currencies.inOutRate === "MXN" ||
        (this.useLogisticsOverride && this.currencies.logisticsCost === "MXN") ||
        hasMXNOtherCost;
    },
    hasValidExchangeRate() {
      if (!this.needsExchangeRate) return true;
      var rate = parseFloat(this.form.dRatePerUSD);
      return rate > 0;
    },
    hasEnoughDataForAlert() {
      if (this.calcMode === "cost") return this.dTotalBoxes > 0 && parseFloat(this.form.dUnitPrice) > 0;
      return this.dTotalBoxes > 0 && parseFloat(this.form.bMarketPrice) > 0;
    },
    canShowResults() {
      if (!this.hasValidExchangeRate) return false;
      if (this.calcMode === "cost") {
        return this.dTotalBoxes > 0 && parseFloat(this.form.dUnitPrice) > 0;
      }
      return this.dTotalBoxes > 0 && parseFloat(this.form.bMarketPrice) > 0;
    },
    priceFOBWithoutMargin() {
      return roundFinancial(this.usdUnitPrice + this.logisticsCostPerBox, 2);
    },
    priceWithoutLogistics() {
      return roundFinancial(this.usdUnitPrice, 2);
    },
    totalTruckFOB() {
      return roundFinancial(this.priceFOBWithoutMargin * this.dTotalBoxes, 2);
    },
    currentFobSellPrice() {
      return this.appliedSellPrice !== null ? this.appliedSellPrice : this.priceFOBWithoutMargin;
    },
    currentFobDiff() {
      return roundFinancial(this.currentFobSellPrice - this.priceFOBWithoutMargin, 2);
    },
    currentFobDiffPercent() {
      if (this.priceFOBWithoutMargin <= 0) return 0;
      return roundFinancial((this.currentFobDiff / this.priceFOBWithoutMargin) * 100, 2);
    },
    currentFobUnitPricePreview() {
      var appliedFob = this.currentFobSellPrice || 0;
      if (appliedFob <= 0) return parseFloat(this.form.dUnitPrice) || 0;
      var newUsdUnit = roundFinancial(appliedFob - this.logisticsCostPerBox, 4);
      if (newUsdUnit < 0) newUsdUnit = 0;
      var rate = parseFloat(this.form.dRatePerUSD) || 1;
      return this.currencies.unitPrice === "MXN"
        ? roundFinancial(newUsdUnit * rate, 2)
        : roundFinancial(newUsdUnit, 2);
    },
    currentFobUnitPriceDiff() {
      return roundFinancial(this.currentFobUnitPricePreview - (parseFloat(this.form.dUnitPrice) || 0), 2);
    },
    fobEditDiff() {
      return roundFinancial((parseFloat(this.fobEditPrice) || 0) - this.priceFOBWithoutMargin, 2);
    },
    fobEditDiffPercent() {
      if (this.priceFOBWithoutMargin <= 0) return 0;
      return roundFinancial((this.fobEditDiff / this.priceFOBWithoutMargin) * 100, 2);
    },
    fobEditUnitPricePreview() {
      var newFob = parseFloat(this.fobEditPrice) || 0;
      if (newFob <= 0) return parseFloat(this.form.dUnitPrice) || 0;
      var newUsdUnit = roundFinancial(newFob - this.logisticsCostPerBox, 4);
      if (newUsdUnit < 0) newUsdUnit = 0;
      var rate = parseFloat(this.form.dRatePerUSD) || 1;
      return this.currencies.unitPrice === "MXN"
        ? roundFinancial(newUsdUnit * rate, 2)
        : roundFinancial(newUsdUnit, 2);
    },
    fobEditUnitPriceDiff() {
      return roundFinancial(this.fobEditUnitPricePreview - (parseFloat(this.form.dUnitPrice) || 0), 2);
    },
    maxPayEditDiff() {
      return roundFinancial(this.maxPayMXN - (parseFloat(this.maxPayEditPrice) || 0), 2);
    },
    maxPayEditDiffPercent() {
      if (this.maxPayMXN <= 0) return 0;
      return roundFinancial((this.maxPayEditDiff / this.maxPayMXN) * 100, 2);
    },
    maxPayEditAvailablePreview() {
      var newMXN = parseFloat(this.maxPayEditPrice) || 0;
      if (newMXN <= 0) return this.availableForProduct;
      var rate = parseFloat(this.form.dRatePerUSD) || 1;
      return roundFinancial(newMXN / rate, 2);
    },
    maxPayEditAvailableDiff() {
      return roundFinancial(this.maxPayEditAvailablePreview - this.availableForProduct, 2);
    },
    showDeleteDialog: {
      get() { return this.deleteTarget !== null; },
      set(v) { if (!v) this.deleteTarget = null; }
    },
    showViewDialog: {
      get() { return this.viewCalculation !== null; },
      set(v) { if (!v) this.viewCalculation = null; }
    },
  },
  methods: {
    startFobEdit() {
      this.fobEditPrice = this.currentFobSellPrice.toString();
      this.showFobEdit = true;
      var self = this;
      this.$nextTick(function () {
        if (self.$refs.fobEditInput) self.$refs.fobEditInput.focus();
      });
    },
    applyFobEdit() {
      var newFob = parseFloat(this.fobEditPrice);
      if (!newFob || newFob <= 0) {
        this.showFobEdit = false;
        return;
      }
      // Solo registra el precio de venta aplicado; el costo (priceFOBWithoutMargin) se mantiene como el calculado.
      this.appliedSellPrice = newFob;
      this.fobEditPrice = "";
      this.showFobEdit = false;
    },
    startMaxPayEdit() {
      this.maxPayEditPrice = "";
      this.showMaxPayEdit = true;
      var self = this;
      this.$nextTick(function () {
        if (self.$refs.maxPayEditInput) self.$refs.maxPayEditInput.focus();
      });
    },
    applyMaxPayEdit() {
      var newMXN = parseFloat(this.maxPayEditPrice);
      if (!newMXN || newMXN <= 0) {
        this.showMaxPayEdit = false;
        return;
      }
      this.appliedMaxPayPrice = newMXN;
      this.maxPayEditPrice = "";
      this.showMaxPayEdit = false;
    },
    fetchExchangeRate() {
      var self = this;
      this.fetchingRate = true;
      fetch("https://api.frankfurter.app/latest?from=USD&to=MXN")
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var rate = data.rates && data.rates.MXN;
          if (rate) {
            self.ratePlaceholder = rate.toFixed(4);
            self.rateHint = data.date;
            self.form.dRatePerUSD = rate.toString();
          }
        })
        .catch(function () {})
        .finally(function () {
          self.fetchingRate = false;
        });
    },
    addOtherCost() {
      this.otherCosts.push({ name: "", amount: "", currency: "USD" });
    },
    removeOtherCost(index) {
      this.otherCosts.splice(index, 1);
    },
    logisticsPercent(type) {
      var total = this.calculatedLogisticsCost;
      if (total <= 0) return 0;
      var value = 0;
      if (type === "inOut") value = this.inOutPerBox;
      else if (type === "customs") value = this.customsPerBox;
      else if (type === "freight") value = this.freightPerBox;
      return (value / total) * 100;
    },
    toPayload(calc) {
      var form = calc.form || {};
      var currencies = calc.currencies || {};
      return {
        dCalcDate: calc.date,
        sCalcMode: calc.calcMode,
        sUnit: calc.unit,
        sProductType: calc.productType || null,
        dUnitPrice: parseFloat(form.dUnitPrice) || 0,
        bMarketPrice: parseFloat(form.bMarketPrice) || 0,
        dBoxesPerPallet: parseFloat(form.dBoxesPerPallet) || 0,
        sTotalPallets: parseFloat(form.sTotalPallets) || 0,
        dTotalBoxesDirect: parseFloat(form.dTotalBoxesDirect) || 0,
        dFreight: parseFloat(form.dFreight) || 0,
        sCustomsFee: parseFloat(form.sCustomsFee) || 0,
        sInOutRate: parseFloat(form.sInOutRate) || 0,
        dRatePerUSD: parseFloat(form.dRatePerUSD) || 1,
        dLogisticsCostOverride: parseFloat(form.dLogisticsCostOverride) || 0,
        sFormNotes: (form.notes && String(form.notes).trim()) || null,
        sUnitPriceCurrency: currencies.unitPrice,
        sFreightCurrency: currencies.freight,
        sCustomsFeeCurrency: currencies.customsFee,
        sInOutRateCurrency: currencies.inOutRate,
        sLogisticsCostCurrency: currencies.logisticsCost,
        bUseLogisticsOverride: !!calc.useLogisticsOverride,
        dTotalBoxes: parseFloat(calc.totalBoxes) || 0,
        dInOutPerBox: parseFloat(calc.inOutPerBox) || 0,
        dCustomsPerBox: parseFloat(calc.customsPerBox) || 0,
        dFreightPerBox: parseFloat(calc.freightPerBox) || 0,
        dLogisticsCostPerBox: parseFloat(calc.logisticsCostPerBox) || 0,
        dPriceFOBWithoutMargin: parseFloat(calc.priceFOBWithoutMargin) || 0,
        dTotalTruckFOB: parseFloat(calc.totalTruckFOB) || 0,
        dAvailableForProduct: parseFloat(calc.availableForProduct) || 0,
        dMaxPayMXN: parseFloat(calc.maxPayMXN) || 0,
        dAppliedSellPrice: calc.appliedSellPrice == null ? null : parseFloat(calc.appliedSellPrice),
        dAppliedMaxPayPrice: calc.appliedMaxPayPrice == null ? null : parseFloat(calc.appliedMaxPayPrice),
        tNotes: (calc.notes && String(calc.notes).trim()) || null,
        aOtherCosts: (calc.otherCosts || []).map(function (oc) {
          return {
            sName: oc.name || "",
            dAmount: parseFloat(oc.amount) || 0,
            sCurrency: oc.currency || "USD",
          };
        }),
      };
    },
    fromPayload(record) {
      if (!record) return record;
      var toNum = function (v) { return v == null ? v : parseFloat(v); };
      var raw = record.OtherCosts || record.aOtherCosts || [];
      return {
        id: record.sCalculatorRecordId,
        date: record.dCalcDate,
        calcMode: record.sCalcMode,
        unit: record.sUnit,
        productType: record.sProductType,
        form: {
          dUnitPrice: toNum(record.dUnitPrice) || 0,
          bMarketPrice: toNum(record.bMarketPrice) || 0,
          dBoxesPerPallet: toNum(record.dBoxesPerPallet) || 0,
          sTotalPallets: toNum(record.sTotalPallets) || 0,
          dTotalBoxesDirect: toNum(record.dTotalBoxesDirect) || 0,
          dFreight: toNum(record.dFreight) || 0,
          sCustomsFee: toNum(record.sCustomsFee) || 0,
          sInOutRate: toNum(record.sInOutRate) || 0,
          dRatePerUSD: toNum(record.dRatePerUSD) || 1,
          dLogisticsCostOverride: toNum(record.dLogisticsCostOverride) || 0,
          notes: record.sFormNotes || "",
        },
        currencies: {
          unitPrice: record.sUnitPriceCurrency,
          freight: record.sFreightCurrency,
          customsFee: record.sCustomsFeeCurrency,
          inOutRate: record.sInOutRateCurrency,
          logisticsCost: record.sLogisticsCostCurrency,
        },
        otherCosts: raw.slice().sort(function (a, b) { return (a.iOrder || 0) - (b.iOrder || 0); }).map(function (oc) {
          return { name: oc.sName || "", amount: toNum(oc.dAmount) || 0, currency: oc.sCurrency };
        }),
        useLogisticsOverride: !!record.bUseLogisticsOverride,
        totalBoxes: toNum(record.dTotalBoxes) || 0,
        inOutPerBox: toNum(record.dInOutPerBox) || 0,
        customsPerBox: toNum(record.dCustomsPerBox) || 0,
        freightPerBox: toNum(record.dFreightPerBox) || 0,
        logisticsCostPerBox: toNum(record.dLogisticsCostPerBox) || 0,
        priceFOBWithoutMargin: toNum(record.dPriceFOBWithoutMargin) || 0,
        totalTruckFOB: toNum(record.dTotalTruckFOB) || 0,
        availableForProduct: toNum(record.dAvailableForProduct) || 0,
        maxPayMXN: toNum(record.dMaxPayMXN) || 0,
        appliedSellPrice: record.dAppliedSellPrice == null ? null : toNum(record.dAppliedSellPrice),
        appliedMaxPayPrice: record.dAppliedMaxPayPrice == null ? null : toNum(record.dAppliedMaxPayPrice),
        notes: record.tNotes,
        created_at: record.created_at,
        tCreatedAtView: record.tCreatedAtView,
      };
    },
    loadCalculations() {
      var self = this;
      DB.get(`${URI}/api/v1/${this.$store.state.language}/administrator/calculator-records`, {
        headers: {
          Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
        }
      })
        .then(function (response) {
          var list = (response.data && response.data.results) || [];
          self.calculations = list.map(function (r) { return self.fromPayload(r); });
        })
        .catch(function () {
          self.calculations = [];
        });
    },
    persistCalculations() {
    },
    openCalculationDetail(item) {
      var self = this;
      if (!item || !item.id) {
        self.viewCalculation = item;
        return;
      }
      DB.get(`${URI}/api/v1/${this.$store.state.language}/administrator/calculator-records/${item.id}`, {
        headers: {
          Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
        }
      })
        .then(function (response) {
          var rec = response.data && response.data.results;
          self.viewCalculation = rec ? self.fromPayload(rec) : item;
        })
        .catch(function () {
          self.viewCalculation = item;
        });
    },
    handleSave() {
      var missingBoxes = this.unit === "boxes" ? !this.form.dTotalBoxesDirect : (!this.form.dBoxesPerPallet || !this.form.sTotalPallets);
      var missingPrice = this.calcMode === "cost" ? !this.form.dUnitPrice : !this.form.bMarketPrice;
      if (missingPrice || missingBoxes) {
        this.mixError("El precio, cajas por pallet y total de pallets son obligatorios");
        return;
      }
      var self = this;
      var pendingFobEdit = parseFloat(this.fobEditPrice);
      var hasPendingFobEdit = this.calcMode === "cost" && !isNaN(pendingFobEdit) && pendingFobEdit > 0;
      var currentAppliedSellPrice = hasPendingFobEdit
        ? pendingFobEdit
        : (this.appliedSellPrice !== null ? this.appliedSellPrice : this.priceFOBWithoutMargin);
      if (hasPendingFobEdit) {
        this.appliedSellPrice = pendingFobEdit;
        this.showFobEdit = false;
        this.fobEditPrice = "";
      }

      var calc = {
        id: this.editingId || Date.now().toString(),
        date: new Date().toISOString(),
        calcMode: this.calcMode,
        unit: this.unit,
        productType: this.productType,
        form: {
          dUnitPrice: parseFloat(this.form.dUnitPrice) || 0,
          bMarketPrice: parseFloat(this.form.bMarketPrice) || 0,
          dBoxesPerPallet: parseFloat(this.form.dBoxesPerPallet) || 0,
          sTotalPallets: parseFloat(this.form.sTotalPallets) || 0,
          dTotalBoxesDirect: parseFloat(this.form.dTotalBoxesDirect) || 0,
          dFreight: parseFloat(this.form.dFreight) || 0,
          sCustomsFee: parseFloat(this.form.sCustomsFee) || 0,
          sInOutRate: parseFloat(this.form.sInOutRate) || 0,
          dRatePerUSD: parseFloat(this.form.dRatePerUSD) || 1,
          dLogisticsCostOverride: parseFloat(this.form.dLogisticsCostOverride) || 0,
          notes: this.form.notes,
        },
        currencies: Object.assign({}, this.currencies),
        otherCosts: JSON.parse(JSON.stringify(this.otherCosts)),
        useLogisticsOverride: this.useLogisticsOverride,
        totalBoxes: this.dTotalBoxes,
        inOutPerBox: this.inOutPerBox,
        customsPerBox: this.customsPerBox,
        freightPerBox: this.freightPerBox,
        logisticsCostPerBox: this.logisticsCostPerBox,
        priceFOBWithoutMargin: this.priceFOBWithoutMargin,
        totalTruckFOB: this.totalTruckFOB,
        availableForProduct: this.availableForProduct,
        maxPayMXN: this.maxPayMXN,
        appliedSellPrice: currentAppliedSellPrice,
        appliedMaxPayPrice: this.calcMode === 'maxpay'
          ? (this.appliedMaxPayPrice !== null ? this.appliedMaxPayPrice : this.maxPayMXN)
          : undefined,
        notes: (this.form.notes || "").trim() || undefined,
      };

      var self = this;
      var payload = self.toPayload(calc);

      if (this.editingId) {
        var idToUpdate = this.editingId;
        DB.patch(
          `${URI}/api/v1/${this.$store.state.language}/administrator/calculator-records/${idToUpdate}`,
          payload,
          {
            headers: {
              Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
            }
          }
        )
          .then(function (response) {
            var rec = response.data && response.data.results;
            var updated = rec ? self.fromPayload(rec) : calc;
            self.calculations = self.calculations.map(function (c) {
              return c.id === idToUpdate ? updated : c;
            });
            self.mixSuccess("Cálculo actualizado exitosamente");
            self.handleReset();
          })
          .catch(function (err) {
            var msg = (err && err.response && err.response.data && err.response.data.message) || "No se pudo actualizar el cálculo";
            self.mixError(msg);
          });
        return;
      }

      DB.post(
        `${URI}/api/v1/${this.$store.state.language}/administrator/calculator-records`,
        payload,
        {
          headers: {
            Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
          }
        }
      )
        .then(function (response) {
          var rec = response.data && response.data.results;
          var saved = rec ? self.fromPayload(rec) : calc;
          self.calculations.unshift(saved);
          self.mixSuccess("Cálculo guardado exitosamente");
          self.handleReset();
        })
        .catch(function (err) {
          var msg = (err && err.response && err.response.data && err.response.data.message) || "No se pudo guardar el cálculo";
          self.mixError(msg);
        });
    },
    handleReset() {
      this.form = {
        dUnitPrice: "",
        bMarketPrice: "",
        dBoxesPerPallet: "40",
        sTotalPallets: "26",
        dTotalBoxesDirect: "",
        dFreight: "",
        sCustomsFee: "",
        sInOutRate: "",
        dRatePerUSD: "",
        dLogisticsCostOverride: "",
        notes: "",
      };
      this.currencies = {
        unitPrice: "MXN",
        freight: "MXN",
        customsFee: "USD",
        inOutRate: "USD",
        logisticsCost: "USD",
      };
      this.otherCosts = [];
      this.useLogisticsOverride = false;
      this.calcMode = "cost";
      this.unit = "pallets";
      this.productType = "fruits";
      this.editingId = null;
      this.fobEditPrice = "";
      this.showFobEdit = false;
      this.appliedSellPrice = null;
      this.maxPayEditPrice = "";
      this.showMaxPayEdit = false;
      this.appliedMaxPayPrice = null;
      this.rateHint = "";
    },
    editCalculation(calc) {
      this.editingId = calc.id;
      this.calcMode = calc.calcMode || "cost";
      this.form.dUnitPrice = calc.form.dUnitPrice.toString();
      this.form.bMarketPrice = (calc.form.bMarketPrice || 0).toString();
      this.form.dBoxesPerPallet = calc.form.dBoxesPerPallet.toString();
      this.form.sTotalPallets = calc.form.sTotalPallets.toString();
      this.form.dTotalBoxesDirect = (calc.form.dTotalBoxesDirect || 0).toString();
      this.form.dFreight = calc.form.dFreight.toString();
      this.form.sCustomsFee = calc.form.sCustomsFee.toString();
      this.form.sInOutRate = calc.form.sInOutRate.toString();
      this.form.dRatePerUSD = calc.form.dRatePerUSD.toString();
      this.form.dLogisticsCostOverride = calc.form.dLogisticsCostOverride.toString();
      this.form.notes = calc.form.notes || "";
      this.currencies = Object.assign({}, calc.currencies);
      this.otherCosts = calc.otherCosts ? JSON.parse(JSON.stringify(calc.otherCosts)) : [];
      this.useLogisticsOverride = calc.useLogisticsOverride || false;
      this.unit = calc.unit || "pallets";
      this.productType = calc.productType;
      this.appliedSellPrice = calc.appliedSellPrice || null;
      this.fobEditPrice = "";
      this.showFobEdit = false;
      this.appliedMaxPayPrice = calc.appliedMaxPayPrice || null;
      this.maxPayEditPrice = "";
      this.showMaxPayEdit = false;
      this.activeTab = 0;
    },
    cancelEdit() {
      this.handleReset();
    },
    confirmDelete() {
      var target = this.deleteTarget;
      var self = this;
      if (!target) {
        this.deleteTarget = null;
        return;
      }
      DB.delete(`${URI}/api/v1/${this.$store.state.language}/administrator/calculator-records/${target}`, {
        headers: {
          Authorization: this.$store.state.sToken ? `Bearer ${this.$store.state.sToken}` : ""
        }
      })
        .then(function () {
          self.calculations = self.calculations.filter(function (c) {
            return c.id !== target;
          });
          self.mixSuccess("Cálculo eliminado exitosamente");
        })
        .catch(function (err) {
          var msg = (err && err.response && err.response.data && err.response.data.message) || "No se pudo eliminar el cálculo";
          self.mixError(msg);
        })
        .finally(function () {
          self.deleteTarget = null;
        });
    },
    formatCurrency(value) {
      try {
        return new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(value);
      } catch (e) {
        return "$" + parseFloat(value).toFixed(2);
      }
    },
    formatDate(dateString) {
      try {
        return new Intl.DateTimeFormat("es-ES", {
          dateStyle: "medium",
          timeStyle: "short",
        }).format(new Date(dateString));
      } catch (e) {
        return dateString;
      }
    },
  },
};
</script>

<style scoped>
.v-data-table >>> th {
  font-family: "montserrat-semibold" !important;
  font-size: 12px !important;
  color: #555 !important;
}
.v-data-table >>> td {
  font-size: 13px !important;
}
.currency-toggle {
  border-radius: 20px !important;
  overflow: hidden;
}
.currency-toggle .v-btn--active {
  background-color: #000000 !important;
  color: #ffffff !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: rgba(0, 0, 0, 0.1) !important;
  border-width: 1px !important;
}
.v-text-field--outlined >>> .v-input__slot {
  background: #f3f3f5 !important;
  min-height: 36px !important;
}
.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-color: #030213 !important;
  border-width: 1.5px !important;
  box-shadow: 0 0 0 3px rgba(3, 2, 19, 0.08) !important;
}
</style>
